import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/** Standard Housefolios launchpad icon green */
export const LAUNCHPAD_ICON_COLOR = '#28a745'
/** DealSauce brand icon color */
export const DEALSAUCE_ICON_COLOR = '#571300'

/**
 * Launchpad Icon Wrapper Component
 *
 * This component consolidates the specific icon styling pattern used in launchpad buttons:
 * "h2" plus centered block layout via style
 *
 * It's designed specifically for the large, centered, green icons in navigation and preference components.
 *
 * @param {Object} props
 * @param {Array} props.icon - FontAwesome icon array [style, iconName]
 * @param {string} props.className - Additional CSS classes (optional)
 * @param {Object} props.style - Additional inline styles (optional)
 * @param {string} props.color - Icon color (defaults to LAUNCHPAD_ICON_COLOR)
 */
const IconWrapper = ({
  icon,
  className = '',
  style = {},
  color = LAUNCHPAD_ICON_COLOR,
  ...props
}) => {
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className || undefined}
      style={{
        display: 'block',
        marginBottom: '0.5rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0.25rem',
        fontSize: '2rem',
        color,
        ...style,
      }}
      {...props}
    />
  )
}

export default IconWrapper
